import React, { useContext } from "react";
import { Card, CopyHash, DataTable, HighlightMatch, KeyValueList, Table, ValueOrPlaceholder, } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { FILE_BROWSER_ROUTES, REPORT_PAGES_ROUTES } from "../../../constants";
import { expandedRowPaginationUpdated, expandedRowSortUpdated, expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectExpandedRowPagination, selectExpandedRowSort, selectFocusedRow, } from "../../../store/signaturesSlice";
import { ComponentList, ExpandedRowDetails } from "../../../ui";
import { ComponentName, ComponentPriorityAndIssuesLink, IssuesList, } from "../../common";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetSignatureSourcesQuery } from "../../services/signatures.api";
import { getRemainingCertificateValidTime } from "../../utils";
import styles from "./signature.module.scss";
const ComponentsTable = ({ signature, index, }) => {
    var _a;
    const { reportId } = useContext(ReportContext);
    const dispatch = useReportDispatch();
    const pagination = useReportSelector((state) => selectExpandedRowPagination(state, signature.thumbprint));
    const sortBy = useReportSelector((state) => selectExpandedRowSort(state, signature.thumbprint));
    const { data, isFetching, isLoading, isError, error } = useGetSignatureSourcesQuery({
        ui_item_id: signature.thumbprint,
        pagination: pagination,
        sort: sortBy,
        ui_id: reportId,
    });
    const handleSortChange = (newSort) => {
        dispatch(expandedRowSortUpdated({
            id: signature.thumbprint,
            sort: newSort,
        }));
    };
    return (React.createElement(ComponentList.Table, { itemId: "signature", rowIndex: index, title: "Files signed with this signature", matchCount: (_a = data === null || data === void 0 ? void 0 : data.match_count) !== null && _a !== void 0 ? _a : 0, queryStatus: getQueryStatus({
            isLoading,
            isFetching,
            isError,
            error,
            data,
        }), totalCount: signature.files_signed, pagination: pagination, onPaginationChange: (newPagination) => dispatch(expandedRowPaginationUpdated({
            id: signature.thumbprint,
            pagination: newPagination,
        })), columns: ComponentList.columns({
            sortBy,
            rowIndex: index,
            onSortChange: handleSortChange,
        }) }, data === null || data === void 0 ? void 0 : data.components.map((component, index) => {
        var _a;
        return (React.createElement(Table.Row, { key: (_a = component.id) !== null && _a !== void 0 ? _a : component.path },
            React.createElement(Table.Cell, null,
                React.createElement(ComponentList.PriorityAndIssues, { component: component, id: index.toString(), badgeWrapper: (target, children) => (React.createElement(ComponentPriorityAndIssuesLink, { htmlId: index.toString(), componentId: component.id, componentPath: component.path, target: target }, children)) })),
            React.createElement(Table.Cell, null,
                React.createElement(ComponentName, { component: component, id: index.toString(), fileBrowserPage: FILE_BROWSER_ROUTES.SIGNATURES_ROUTE })),
            React.createElement(Table.Cell, null,
                React.createElement(ComponentList.Path, { path: component.path }))));
    })));
};
const Signature = ({ signature, searchRegex, index, }) => {
    const dispatch = useReportDispatch();
    const focusedRow = useReportSelector(selectFocusedRow);
    const expanded = useReportSelector((state) => selectExpandedRow(state, signature.thumbprint));
    return (React.createElement(DataTable.ExpandedRow, { id: `signatures-expand-row-${index}`, expanded: expanded, focused: focusedRow === signature.thumbprint, onClick: () => dispatch(focusedRowUpdated(signature.thumbprint)), onChange: (isExpanded) => dispatch(expandedRowsUpdated({ id: signature.thumbprint, expand: isExpanded })) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement(HighlightMatch, { value: signature.identity, regex: searchRegex })),
            React.createElement(Table.Cell, null,
                React.createElement("code", null, signature.serial_number)),
            React.createElement(Table.Cell, { title: signature.valid_to }, getRemainingCertificateValidTime(signature.valid_to)),
            React.createElement(Table.Cell, null,
                React.createElement(ValueOrPlaceholder, { value: signature.violations.length })),
            React.createElement(Table.Cell, null, signature.files_signed.toLocaleString())),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                React.createElement(ExpandedRowDetails.Aside, null,
                    React.createElement(Card.Card, null,
                        React.createElement(Card.Title, null, "Signature details"),
                        React.createElement(Card.Content, null,
                            React.createElement(KeyValueList, { list: {
                                    Issuer: signature.issuer,
                                    Thumbprint: (React.createElement("div", { className: styles.thumbprint },
                                        React.createElement("span", null, signature.thumbprint),
                                        React.createElement(CopyHash, { id: `${index}-copy-thumbprint-to-clipboard`, sha256: signature.thumbprint, name: "thumbprint" }))),
                                    "Valid from": signature.valid_from,
                                    "Valid to": signature.valid_to,
                                } }))),
                    React.createElement(IssuesList, { violations: signature.violations, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE })),
                React.createElement(ExpandedRowDetails.Main, null,
                    React.createElement(ComponentsTable, { signature: signature, index: index }))))));
};
export default Signature;
//# sourceMappingURL=Signature.js.map